<template>
  <section class="section-book-cleaner-from-profile form-book-cleaner">
    <div class="px-3 pt-3 pb-2">
      <div class="form-group">
        <h4 class="pb-2">{{ $t('message.booking.new_booking.choose_a_service') }}</h4>
        <div class="select-jumbo">
          <select class="form-control" v-model="parentServiceId" @change="setParentService">
            <option :value="item.service_id" v-for="item in professional.professional_services">
              {{ getService(item.service_id) | multiLangName }}
            </option>
          </select> 
        </div>
      </div>
    </div>
    <section v-if="professionalCalendar">
      <div class="row" v-if="parentService && parentService.can_book_package">
        <div class="col">
          <booking-plan :packageType="packageType" @selectPackageType="selectPackageType"/>
        </div>
      </div>
      <div class="row mt-2"
           v-if="state.userPlaces && checkUserPlaces(state.userPlaces, professional.province_id)">
        <div class="col-12">
          <div class="form-group">
            <h4 class="pb-2">{{ $t('message.booking.booking_step.my_place') }}</h4>
            <div class="select-jumbo">
              <select class="form-control" v-model="selectedUserPlaceId" @change="syncUserPlaceData">
                <option value="">
                  {{ $t('message.booking.booking_step.please_select') }}
                </option>
                <option :value="userPlace.id" v-for="userPlace in state.userPlaces"
                        v-if="state.userPlaceCities[userPlace.id] === professional.province_id">
                  {{ userPlace.place_name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <!-- /.row user places -->

      <div class="row mt-3" v-if="parentServiceId === 1">
        <div class="col-12">
          <div class="form-group mb-2">
            <h4 class="pb-2">{{ $t('message.booking.booking_step.accommodation') }}</h4>
            <div class="select-jumbo">
              <select class="form-control" v-model="selectedPlaceSize" @change="setWorkHour">
                <option :value="sortedPlaceSizes[index].id" v-for="placeSize, index in sortedPlaceSizes">
                  {{ placeSize | multiLangName }}
                </option>
              </select>
            </div>
          </div>

          <div class="text-primary pl-1">
            {{ $t('message.booking.booking_step.recommend') }} {{ $t(globalState.durations[selectedPlaceSize]) }}
          </div>

          <div class="select-jumbo mt-2">
            <select class="form-control" v-model="selectedWorkHour" @change="initAvailableTimes">
              <option :value="index" v-for="workHour, index in globalState.workHours">
                {{ $t(workHour) }}
              </option>
            </select>
          </div>

          <div class="mt-2 pl-1 text-orange">* {{ $t('message.booking.new_booking.excluding_break_time') }}</div>
        </div>
      </div>
      <!-- /.row place sizes -->

      <div class="row mt-3" v-else-if="parentService && parentService.child_services_text">
        <div class="col-12">
          <div class="form-group">
            <h4 class="pb-2" v-if="parentService && parentService.child_services_text">
              {{ ($i18n.locale === 'th') ? parentService.child_services_text.title_th : parentService.child_services_text.title_en }}
            </h4>
            <div class="select-jumbo" :class="{'form-alert': errorSelectedService}">
              <select v-model="selectedServiceId">
                <option :value="null">
                  {{ ($i18n.locale === 'th') ? parentService.child_services_text.placeholder_th : parentService.child_services_text.placeholder_en }}
                </option>
                <option :value="childServices[index].id" v-for="service, index in childServices">
                  {{ service | multiLangName }}
                </option>
              </select>
            </div>
            <div v-if="errorSelectedService" class="form-alert-text -status-alert">{{ errorSelectedServiceText }}</div>
          </div>
        </div>
      </div>
      <!-- /.row child services -->

      <div class="row mt-3" v-else-if="parentService && parentService.has_service_items">
        <div class="col-12">
          <div class="d-flex justify-content-start align-items-center">
            <div class="flex-fill">
              <h4>{{ $t('message.service_item.select') }}</h4>
            </div>
            <div v-if="serviceItems">
              <a href="" class="text-info" @click.prevent="clearSelectedServiceItems()">
                {{ $t('message.service_item.clear') }}
              </a>
            </div>
          </div>
          <div class="card pointer-item mb-1" 
                :class="[errorServiceItems ? 'border-danger' : 'border-divider']"
                @click="openServiceItemModal()">
            <div class="card-body">
              <div class="d-flex justify-content-start align-items-center" v-if="!serviceItems">
                <div><img :src="parentService.icon_url" width="24"/></div>
                <div class="flex-fill px-3">{{ $t('message.service_item.select') }}</div>
                <div><i class="fal fa-plus-circle text-info fa-lg"></i></div>
              </div>
              <div class="d-flex justify-content-start align-items-top" v-else>
                <div>
                  <img :src="parentService.icon_url" width="32" class="active-svg-icon"/>
                </div>
                <div class="flex-fill px-3">
                  <div class="mb-2"><strong>{{ $t('message.service_item.list_of_items') }}</strong></div>
                  <div v-for="serviceItem in serviceItems">
                    {{ serviceItem | multiLangName }}: {{ serviceItem.count }} {{ serviceItem.item_unit | multiLangName }}
                  </div>
                </div>
                <div>
                  <button class="btn btn-sm btn-outline-info rounded-pill">แก้ไข</button>
                </div>
              </div>
              <div class="d-flex justify-content-start align-items-center" v-if="serviceItems">
                <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                <div class="text-info mt-2">
                  {{ $t('message.service_item.remark') }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="errorServiceItems" class="form-alert-text -status-alert">{{ $t('message.required_selection') }}</div>
        </div>
      </div>
      <!-- /.row child services -->

      <div class="row mt-3" v-if="packageType">
        <div class="col-12">
          <h4 class="pb-2">{{ $t('message.booking.new_booking.pick_a_date') }}</h4>
        </div>
        <div class="col-12 mb-4">
          <div class="text-remark mt-1">
            {{ $t('message.booking.new_booking.select_multi_dates') }} - {{ packageType | multiLangName }}
          </div>
          <professional-multi-dates-calendar
            @updateData="updateMultiDates"
            @updateNumPackageSelectedDates="updateNumPackageSelectedDates"
            :professionalId="professionalId"
            :maxNum="packageType.num_per_package"
            :workHours="selectedWorkHour"
            :packageType="packageType"/>
          <section class="mt-4" v-if="multiDates && multiDates.length > 0">
            <span class="badge badge-pill py-2 px-3 mr-2 mb-2 badge-light" v-for="date in multiDates">
              {{ date | shortDate }}
            </span>
          </section>
          <div v-if="errorBookingDate" class="form-alert-text -status-alert">{{ errorBookingDateText }}</div>
        </div>
      </div>

      <div class="row mt-3" v-else>
        <div class="col-12">
          <h4 class="pb-2">{{ $t('message.booking.new_booking.pick_a_date') }}</h4>
        </div>
        <div class="col-6 pr-2">
          <div class="form-group">
            <input type="text"
                   placeholder="DD/MM/YYYY"
                   class="form-control -date-picker input-jumbo"
                   :class="{'form-alert': errorBookingDate}"
                   @change="displayAvailableDuration"
                   v-pikaday:professionalCalendar="professionalCalendar"
                   ref="cleaningDate" readonly>
            <span class="far fa-calendar-alt input-text-icon"></span>
            <div v-if="errorBookingDate" class="form-alert-text -status-alert">{{ errorBookingDateText }}</div>
          </div>
        </div>
        <!-- /. calendar -->

        <div class="col-6 pl-2">
          <div class="form-group">
            <template v-if="!isFetchingProfessionalCalendarJobs">
              <div v-if="availableTimes.length > 0">
                <div class="select-jumbo">
                  <select style="background: white;" class="form-control" v-model="selectedTime">
                    <option :value="time" v-for="time in availableTimes">{{ time }}</option>
                  </select>
                  <span class="far fa-clock input-text-icon"></span>
                </div>
              </div>
              <div class="select-jumbo" v-else-if="selectedDate === null">
                <div class="select-jumbo">
                  <select style="background: white;" class="form-control" v-model="selectedTime">
                    <option :value="time" v-for="time in globalState.times">{{ time }}</option>
                  </select>
                  <span class="far fa-clock input-text-icon"></span>
                </div>
              </div>
              <div v-else>
                <span class="text-orange">{{ $t('message.alert.sold_out') }}</span>
              </div>
            </template>
            <template v-else>
              <div class="text-center">
                <img src="/static/img/ring.gif" width="32"> {{ $t('message.button.loading') }}
              </div>
            </template>
          </div>
        </div>
        <!-- /. time -->
      </div>
      <!-- /.row -->

      <div class="row">
        <div class="col">
          {{ $t('message.booking.new_booking.booking_today_remark') }}
          <a href="https://line.me/R/ti/p/%40hnk7011n" target="_blank">@beneat</a>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 mb-1" v-if="partialBlockedDuration">
          <ul class="list-unstyled calendar-job-list">
            <li>
              {{ $t('message.professional.available_time') }}:
              <span class="text-primary">
                <span v-if="partialBlockedDuration === ''">{{ $t('message.professional.all_day') }}</span>
                <span v-else="">{{ partialBlockedDuration }}</span>
              </span>
            </li>
            <template v-if="professionalCalendarJobs">
              <li v-for="job in professionalCalendarJobs">
                {{ $t('message.professional.booked_by_other_user') }}:
                <span class="text-orange"
                      v-html="$options.filters.cleaningDuration(job.cleaning_date, job.work_hour)"></span>
              </li>
            </template>
          </ul>
        </div>
      </div>
      <!-- /. available time -->
      <div class="row mt-3">
        <div class="col-md-12">
          <ul class="list-unstyled summary-list">
            <li>
              <div class="row">
                <div class="col-8 p-0">
                  <h3 class="mb-2">
                    {{ $t('message.booking.new_booking.subtotal') }}
                  </h3>
                </div>
                <div class="col-4 p-0 text-right">
                  <h3 class="mb-2 text-primary">
                    {{ totalPrice | currencyNoDecimal }}
                  </h3>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- /. row -->

      <div class="row">
        <div class="col-12 text-danger mb-2" v-if="professional.active === 0">
          <hr class="no-space">
          {{ $t('message.professional.inactive_status') }}
        </div>

        <div class="col-12 text-center">
          <button class="btn btn-info btn-block"
                  :disabled="(professional.active === 0 || professional.professional_group_id > 1)"
                  @click="checkProfessionalAvailable()">
            <template v-if="professional.is_favorited_user">
              <i class="fas fa-bolt -status-instant-book -button"></i>
              {{ $t(isCheckingTextInstantBook) }}
            </template>
            <template v-else>
              {{ $t(isCheckingText) }}
            </template>
          </button>
          <template v-if="$mq.desktop && user && hasPaidOrder && professional.active === 1">
            <div class="my-1">- {{ $t('message.hero.or') }} -</div>
            <router-link tag="a"
                         :to="{ path: '/message', query: { cid: 0, pid:$route.params.id }}"
                         class="btn btn-outline-info btn-block">
              {{ $t('message.professional.contact_cleaner') }}
            </router-link>
          </template>
        </div>
      </div>
      <!-- /. row -->
      <div class="row">
        <div class="col-12">
          <hr>
        </div>
        <div class="col-10 col-lg-10 text-recommend">
          {{ $t('message.booking.choose_cleaner_step.book_on_beneat_cleaning') }}
          <a href="/safety" class="text-primary-link" target="_blank">
            {{ $t('message.booking.choose_cleaner_step.learn_more') }}
          </a>
        </div>
        <div class="col-2 col-lg-2">
          <img src="/static/img/ic-idea.svg" class="img-fluid">
        </div>
      </div>
      <!-- /. row -->
    </section>
    <section v-else>
      <loader/>
    </section>
    <!-- Service items modal -->
    <service-item-modal v-if="parentService && parentService.has_service_items" 
                        ref="serviceItemModal"
                        :parentService="parentService"
                        @selectServiceItems="setServiceItems"/>
  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import Loader from '../../loader/Loader'
  import BookingPlan from '../../booking/newSteps/components/BookingPlan'
  import ServiceItemModal from '../../booking/components/ServiceItemModal'
  import moment from 'moment-timezone'
  import provinceHelpers from '../../../helpers/provinceHelpers'
  import packageHelpers from '../../../helpers/packageHelpers'
  import userEventLogHelpers from '../../../helpers/userEventLogHelpers'
  import serviceHelpers from '../../../helpers/serviceHelpers'
  import insiderHelpers from '../../../helpers/insiderHelpers'
  
  export default {
    props: ['professional', 'from'],
    components: {
      BookingPlan,
      ServiceItemModal,
      Loader
    },
    data () {
      return {
        professionalId: this.$route.params.id,
        parentServiceId: 1,
        parentService: null,
        selectedServiceId: 1,
        selectedUserPlaceId: '',
        selectedProvinceId: 1,
        selectedDate: null,
        selectedTime: '07:00',
        selectedWorkHour: '2.0',
        selectedPlaceSize: 1,
        email: '',
        costPerHour: this.professional.cost_per_hour,
        partialBlockedDuration: null,
        availableStartTime: null,
        availableEndTime: null,
        availableTimes: [],
        sortBy: (this.$i18n.locale === 'th') ? 'name_th' : 'name_en',
        loadingAvailableTimes: false,
        multiDates: null,
        packageType: null,
        errorBookingDate: false,
        errorBookingDateText: null,
        errorSelectedService: false,
        errorSelectedServiceText: null,
        errorServiceItems: false,
        mapDatesTimes: {},
        childServices: null,
        totalPrice: null,
        numPackageSelectedDates: 0,
        serviceItems: null
      }
    },
    computed: {
      ...mapState('professional', ['hasPaidOrder']),
      ...mapGetters({
        isChecking: 'booking/getIsChecking',
        isCheckingText: 'booking/getIsCheckingText',
        isCheckingTextInstantBook: 'booking/getIsCheckingInstantBook',
        isFetchingProfessionalCalendarJobs: 'professionalCalendar/getIsFetchingProfessionalCalendarJobs',
        globalState: 'globalVal/getState',
        preBookingData: 'booking/getPreBookingData',
        professionalAvailable: 'booking/getProfessionalAvailable',
        professionalCalendar: 'professionalCalendar/getProfessionalCalendar',
        professionalCalendarJobs: 'professionalCalendar/getProfessionalCalendarJobs',
        professionalCalendarState: 'professionalCalendar/getState',
        provinceDiscounts: 'booking/getProvinceDiscounts',
        state: 'booking/getState',
        user: 'auth/getUser'
      }),
      sortedPlaceSizes () {
        return this._.orderBy(this.globalState.placeSizes, ['id'], ['asc'])
      }
    },
    watch: {
      parentServiceId () {
        this.parentService = this.globalState.services[this.parentServiceId]
      },
      professionalCalendar () {
        this.loadFullyBookedDates()
      },
      professionalCalendarJobs () {
        this.initAvailableTimes()
      },
      isChecking () {
        if (!this.state.isChecking && this.state.availability === true && this.$refs.cleaningDate.value) {
          this.setPreBookingDataAndGoToCheckout()
        }
      },
      selectedServiceId () {
        // Clear error alert
        this.errorSelectedService = false
        this.errorSelectedServiceText = null
        // Get child service
        const selectedService = this.getChildService()
        if (selectedService) {
          // Set work hours
          this.selectedWorkHour = selectedService.duration
        }
      },
      selectedWorkHour () {
        this.loadFullyBookedDates()
        this.calculateTotalPrice()
      },
      totalPrice () {
        if (this.totalPrice) {
          // Insider product page event
          const totalPrice = serviceHelpers.converStringToNumber(this.totalPrice)
          const productParams = {
            user: this.user,
            serviceId: this.selectedServiceId,
            provinceId: this.selectedProvinceId,
            totalPrice: totalPrice,
            professionalId: this.professionalId,
            bookingCountType: (!this.packageType) ? 'one_time' : 'multiple_times',
            isNoDateTimeBooking: false
          }
          insiderHelpers.productViewEvent(productParams)
        }
      }
    },
    methods: {
      getService (serviceId) {
        return this.globalState.services[serviceId]
      },
      canDisplayService (serviceId) {
        let result = false
        const globalService = this.globalState.services[serviceId]
        if (globalService && globalService.is_hidden === 0) {
          result = true
        }
        return result
      },
      checkUserPlaces (userPlaces, provinceId) {
        let num = 0
        for (let key in userPlaces) {
          const userPlace = userPlaces[key]
          if (userPlace.province_id === provinceId) {
            num += 1
          }
        }
        return num > 0
      },
      updateMultiDates (mapDatesTimes) {
        this.errorBookingDate = false
        this.errorBookingDateText = null
        this.mapDatesTimes = mapDatesTimes
        // console.log('map dates times', this.mapDatesTimes)
      },
      updateNumPackageSelectedDates (numDates) {
        this.numPackageSelectedDates = numDates
        this.calculateTotalPrice()
      },
      selectPackageType (selectedCategory) {
        this.packageType = null
        if (selectedCategory && this.globalState.packageTypes) {
          for (const packageType of this.globalState.packageTypes) {
            if (packageType.category === selectedCategory) {
              this.packageType = packageType
              break
            }
          }
        }
        this.calculateTotalPrice()
      },
      parseTime (s) {
        const c = s.split(':')
        return parseInt(c[0]) * 60 + parseInt(c[1])
      },
      checkAvailableTime (startTime, professionalCalendarJobs) {
        let result = true
        if (professionalCalendarJobs) {
          const hours = Number(this.selectedWorkHour) + 0.5
          if (this.selectedDate) {
            const endTime = moment(this.selectedDate + ' ' + startTime).add(hours, 'hours').format('HH:mm')
            for (let job of professionalCalendarJobs) {
              if (startTime >= job.start_time && startTime <= job.end_time) {
                result = false
                break
              } else {
                const minutes = this.parseTime(startTime) - this.parseTime(job.end_time)
                if (startTime < job.start_time && endTime >= job.start_time) {
                  result = false
                  break
                } else if (startTime > job.end_time && minutes < 60) {
                  result = false
                  break
                }
              }
            }
          }
        }
        // Check available end time comparing with duration if the selected date is partial blocked date
        if (result === true && this.availableEndTime) {
          const minutes = this.parseTime(this.availableEndTime) - this.parseTime(startTime)
          const endMinute = 60 * Number(this.selectedWorkHour)
          if (minutes < endMinute) {
            result = false
          }
        }
        return result
      },
      initAvailableTimes () {
        this.availableTimes.length = 0
        if (this.availableStartTime === null) {
          for (let time in this.globalState.times) {
            if (this.professionalCalendarJobs) {
              const result = this.checkAvailableTime(time, this.professionalCalendarJobs)
              if (result) {
                this.availableTimes.push(time)
              }
            } else {
              this.availableTimes.push(time)
            }
          }
        } else {
          for (let time in this.globalState.times) {
            if (time >= this.availableStartTime && time <= this.availableEndTime) {
              const result = this.checkAvailableTime(time, this.professionalCalendarJobs)
              if (result) {
                this.availableTimes.push(time)
              }
            }
          }
        }
        // Check if selected time is in available time then set its value
        const index = this.availableTimes.indexOf(this.selectedTime)
        if (index > -1) {
          this.selectedTime = this.availableTimes[index]
        } else {
          this.selectedTime = this.availableTimes[0]
        }
      },
      setWorkHour () {
        this.selectedWorkHour = this.globalState.placeSizeWorkHours[this.selectedPlaceSize]
        this.initAvailableTimes()
      },
      syncUserPlaceData () {
        if (this.selectedUserPlaceId) {
          this.selectedProvinceId = this.state.userPlaceCities[this.selectedUserPlaceId]
          this.selectedPlaceSize = this.state.userPlaceSizes[this.selectedUserPlaceId]
          this.selectedWorkHour = this.globalState.placeSizeWorkHours[this.selectedPlaceSize]
          // If my place has work our then adopt it with my place selection
          if (this.state.userPlaceWorkHours[this.selectedUserPlaceId]) {
            this.selectedWorkHour = this.state.userPlaceWorkHours[this.selectedUserPlaceId]
          }
          this.initAvailableTimes()
        } else {
          this.selectedPlaceSize = 1
          this.selectedWorkHour = '2.0'
        }
        this.calculateTotalPrice()
      },
      displayAvailableDuration () {
        // Clear error alert
        this.errorBookingDate = false
        this.errorBookingDateText = null

        this.partialBlockedDuration = ''
        this.selectedDate = moment(this.$refs.cleaningDate.value, 'DD/MM/YYYY').format('YYYY-MM-DD')
        const blockedDates = this.professionalCalendar.blockedDates
        this.availableStartTime = null
        this.availableEndTime = null

        for (let key in blockedDates) {
          const blockedDate = blockedDates[key]
          if (blockedDate.blocked_type === 'partial' && blockedDate.date === this.selectedDate) {
            this.availableStartTime = blockedDate.start_time
            this.availableEndTime = blockedDate.end_time
            this.partialBlockedDuration = this.availableStartTime + ' - ' + this.availableEndTime
          }
        }

        if (this.availableStartTime === null) {
          this.selectedTime = '07:00'
        } else {
          this.selectedTime = this.availableStartTime
        }

        // Fetch professional calendar jobs
        const queryData = {
          professional_id: this.professionalId,
          cleaning_date: this.selectedDate
        }
        this.$store.dispatch('professionalCalendar/LOAD_PROFESSIONAL_CALENDAR_JOB_LIST', queryData)
        this.initAvailableTimes()
      },
      checkProfessionalAvailable () {
        if (!this.selectedServiceId) {
          this.errorSelectedServiceText = this.$i18n.t('message.required_selection')
          this.errorSelectedService = true
        }
        if (!this.packageType) {
          let isValid = true
          if (this.parentService && this.parentService.has_service_items && !this.serviceItems) {
            this.errorServiceItems = true
            isValid = false
          }
          if (!this.selectedDate) {
            this.errorBookingDateText = this.$i18n.t('message.booking.new_booking.date_is_required')
            this.errorBookingDate = true
            isValid = false
          }
          if (isValid) {
            const submitData = {
              professional_id: this.professionalId,
              cleaning_date: this.selectedDate,
              cleaning_time: this.selectedTime,
              work_hour: this.selectedWorkHour,
              province_id: this.professional.province_id
            }
            this.$store.dispatch('booking/CHECK_PROFESSIONAL_AVAILABLE', submitData)
          }
        } else {
          const countDateTime = Object.keys(this.mapDatesTimes).length
          let isValid = false
          if (!this.selectedServiceId) {
            isValid = false
          }
          if (countDateTime === 0) {
            isValid = false
            this.errorBookingDateText = this.$i18n.t('message.booking.new_booking.date_is_required')
            this.errorBookingDate = true
          } else {
            switch (this.packageType.category) {
              case 'normal':
                isValid = (countDateTime === this.packageType.num_per_package)
                break
              case 'unlimited':
                isValid = (countDateTime >= this.packageType.min_qty && countDateTime <= this.packageType.num_per_package)
                break
            }
            if (!isValid) {
              this.errorBookingDateText = this.$i18n.t('message.booking.new_booking.missing_dates_of_package')
              this.errorBookingDate = true
            }
          }
          if (isValid) {
            this.setPreBookingDataAndGoToCheckout()
          }
        }
      },
      checkLogin () {
        const parentComponent = (this.from === 'cleanerDetail') ? this.$parent.$parent : this.$parent.$parent.$parent.$parent
        // console.log('check parentComponent', this.from, parentComponent)
        if (('isLoggingIn' in window.localStorage && window.localStorage.getItem('isLoggingIn') === 'false')) {
          if (this.user === null) {
            parentComponent.openModal('login')
          }
        } else {
          parentComponent.openModal('login')
        }
      },
      clearOldBookingData () {
        // Remove pre booking data
        this.$store.commit('booking/SET_PRE_BOOKING_DATA', null)
        // Remove relected professional data
        this.$store.commit('booking/SET_SELECTED_PROFESSIONAL', null)
        // Remove new order data
        // this.$store.commit('booking/SET_NEW_ORDER_DATA', null)
        // Remove preCheckoutData
        this.$store.commit('booking/SET_PRE_CHECKOUT_DATA', null)
        // Remove promo code
        this.$store.commit('promoCode/SET_APPLIED_PROMO_CODE', null)
        // Remove extras
        this.$store.commit('extras/SET_APPLIED_EXTRAS', null)
        this.$store.commit('extras/SET_HAS_APPLIED_EXTRAS', false)
      },
      calculateTotalPrice () {
        let totalPrice = 0
        if (this.parentServiceId === 1) {
          this.costPerHour = parseInt(this.costPerHour)
          this.selectedWorkHour = parseFloat(this.selectedWorkHour).toFixed(1)
          totalPrice = this.costPerHour * this.selectedWorkHour
          const discount = provinceHelpers.getProvinceDiscount(this.globalState.provinceDiscounts,
            this.selectedProvinceId, this.selectedWorkHour)
          if (discount) {
            let discountCost = (totalPrice * discount) / 100
            discountCost = Math.round(discountCost * 100) / 100
            totalPrice = totalPrice - discountCost
          }
        } else {
          const selectedService = this.getChildService()
          totalPrice = (selectedService) ? selectedService.cost : 0
        }
        if (this.serviceItems) {
          totalPrice = serviceHelpers.getTotalPriceOfServiceItems(this.serviceItems)
        }

        // Check package type selection
        if (this.packageType) {
          let discountPercent = 0
          switch (this.packageType.category) {
            case 'normal':
              const numPerPackage = this.packageType.num_per_package
              totalPrice = totalPrice * numPerPackage
              // Package discount
              discountPercent = this.packageType.discount
              break
            case 'unlimited':
              totalPrice = totalPrice * this.numPackageSelectedDates
              const packageTypeDiscount = packageHelpers.getUnlimitedPackageDiscount(this.packageType,
                this.numPackageSelectedDates)
              // Package discount
              if (packageTypeDiscount) {
                discountPercent = packageTypeDiscount.discount
              }
              break
          }
          if (discountPercent > 0) {
            let discountValue = (totalPrice * discountPercent) / 100
            discountValue = Math.round(discountValue * 100) / 100
            totalPrice = totalPrice - discountValue
          }
        }
        if (typeof totalPrice === 'string' && !isNaN(totalPrice)) {
          totalPrice = Number(totalPrice)
        }
        this.$store.commit('booking/UPDATE_TOTAL_PRICE', totalPrice)
        this.totalPrice = totalPrice
      },
      getChildService () {
        let selectedService = null
        if (this.selectedServiceId > 1) {
          const datas = this.childServices
          for (let key in datas) {
            const service = datas[key]
            if (this.selectedServiceId === service.id) {
              selectedService = service
              break
            }
          }
        }
        return selectedService
      },
      setPreBookingDataAndGoToCheckout () {
        try {
          // console.log('test total price', this.totalPrice)
          const cleaningDate = (this.packageType) ? null : this.$refs.cleaningDate.value
          // Check case ironing service
          const service = this.getChildService()
          if (service) {
            // Update total price after checking provider availability
            this.$store.commit('booking/UPDATE_TOTAL_PRICE', service.cost)
          }
          if (this.serviceItems) {
            const totalPrice = serviceHelpers.getTotalPriceOfServiceItems(this.serviceItems)
            // Update total price after checking provider availability
            this.$store.commit('booking/UPDATE_TOTAL_PRICE', totalPrice)
          }
          // Set pre-booking data without email
          const preBookingData = {
            service_id: this.selectedServiceId,
            user_place_id: this.selectedUserPlaceId,
            province_id: this.selectedProvinceId,
            cleaning_date: cleaningDate,
            cleaning_time: this.selectedTime,
            work_hour: this.selectedWorkHour,
            init_work_hour: this.selectedWorkHour,
            place_size_id: this.selectedPlaceSize,
            email: '',
            service: service,
            package_type: this.packageType
          }
          // Set multi dates for package booking
          if (this.packageType) {
            const multiDatesTimes = []
            for (let key in this.mapDatesTimes) {
              const selectedTime = this.mapDatesTimes[key]
              const dateTime = key + ' ' + selectedTime
              multiDatesTimes.push(dateTime)
            }
            preBookingData.multi_dates_times = multiDatesTimes
          }
          // Check service items
          if (this.serviceItems) {
            preBookingData.service_items = this.serviceItems
            let workHours = 0.0
            for (const serviceItem of this.serviceItems) {
              if (serviceItem.duration_conditions) {
                workHours += serviceHelpers.getServiceItemDuration(serviceItem.count, serviceItem)
              } else if (serviceItem.duration) {
                workHours += serviceItem.count * serviceItem.duration
              }
            }
            preBookingData.work_hour = workHours
            preBookingData.init_work_hour = workHours
          }
          if (this.user) {
            preBookingData.email = this.user.email
          }
          this.$store.commit('booking/SET_PRE_BOOKING_DATA', preBookingData)

          // Set selected professional
          const selectedProfessional = {
            id: this.professionalId,
            name: this.professional.name,
            picture: this.professional.picture,
            jobQty: this.professional.job_qty,
            active: this.professional.active,
            province_id: this.professional.province_id,
            is_excellent: this.professional.is_excellent,
            professional_services: this.professional.professional_services,
            latitude: this.professional.latitude,
            longitude: this.professional.longitude
          }
          this.$store.commit('booking/SET_SELECTED_PROFESSIONAL', selectedProfessional)

          if (this.user === null || (this.user && Number(this.user.id) === 0)) {
            this.checkLogin()
          } else {
            // Go to contact process of booking
            // Set booking from in order to back to previous page correctly
            const bookingFrom = {
              from: 'cleanerDetail',
              professionalId: this.professionalId
            }
            // Hide book cleaner modal and remove style to show scrollbar
            window.$('.modal').modal('hide')
            window.$('html, body').removeAttr('style')
            this.$store.commit('booking/SET_BOOKING_FROM', bookingFrom)
            this.$router.push('/booking/checkout')
          }
        } catch (e) {
          console.log(e.message)
        }
      },
      generateChildServices () {
        if (this.parentService && this.parentService.child_services_text) {
          this.selectedServiceId = null
          this.childServices = {}
          const datas = this.globalState.services
          let i = 0
          for (let key in datas) {
            const service = datas[key]
            if (service.parent_id === this.parentServiceId) {
              // Bathroom cleaning child services based on province
              if (service.province_id === 0 || Number(this.selectedProvinceId) === service.province_id) {
                this.childServices[i] = {
                  id: service.id,
                  parent_id: service.parent_id,
                  name_th: service.name_th,
                  name_en: service.name_en,
                  duration: service.duration,
                  cost: service.cost
                }
                i += 1
              }
            }
          }
          this.selectedServiceId = this.childServices[0].id
        }
      },
      loadFullyBookedDates () {
        const currentDate = new Date()
        const startDate = moment(currentDate).format('YYYY-MM-DD')
        const queryData = {
          professional_id: this.professionalId,
          start_date: startDate,
          work_hour: this.selectedWorkHour
        }
        this.$store.dispatch('professionalCalendar/LOAD_SOLD_OUT_DATES', queryData)
      },
      initBookingData () {
        if (this.professional) {
          this.selectedProvinceId = this.professional.province_id
          // Generate child services
          this.generateChildServices()

          // Fetch professional calendar
          const currentDate = new Date()
          const startDate = moment(currentDate).format('YYYY-MM-DD')
          const endDate = moment(currentDate).add(12, 'M').endOf('month').format('YYYY-MM-DD')
          const queryProfessionalCalendarData = {
            professional_id: this.professionalId,
            start_date: startDate,
            end_date: endDate
          }
          this.$store.dispatch('professionalCalendar/LOAD_PROFESSIONAL_CALENDAR', queryProfessionalCalendarData)

          // Fetch user places
          const queryUserPlaceData = {
            user_id: 0,
            province_id: this.professional.province_id
          }
          if (this.user) {
            queryUserPlaceData.user_id = this.user.id
          }
          this.$store.dispatch('booking/LOAD_USER_PLACE_LIST', queryUserPlaceData)
        }

        if (this.preBookingData) {
          this.selectedUserPlaceId = this.preBookingData.user_place_id
          this.selectedDate = this.preBookingData.cleaning_date
          this.selectedTime = this.preBookingData.cleaning_time
          this.selectedCity = this.preBookingData.province_id
          this.selectedPlaceSize = this.preBookingData.place_size_id
          this.selectedWorkHour = this.preBookingData.work_hour
          this.$refs.cleaningDate.value = this.selectedDate
        }

        this.initAvailableTimes()
        this.calculateTotalPrice()
        const callbackData = {
          parentServiceId: this.parentServiceId,
          childServices: this.childServices
        }
        this.$emit('changedParentService', callbackData)
      },
      setParentService (event) {
        // Clear error alert
        this.errorBookingDate = false
        this.errorBookingDateText = null
        this.errorSelectedService = false
        this.errorSelectedServiceText = null
        // Clear service items
        this.serviceItems = null
        this.errorServiceItems = false
        const serviceId = Number(event.target.value)
        this.parentService = this.globalState.services[serviceId]
        this.parentServiceId = serviceId
        this.selectedServiceId = serviceId
        this.initBookingData()
        // Save user event log
        userEventLogHelpers.logEvent('begin_booking_professional', {
          service_id: serviceId,
          professional_id: this.professionalId
        })
      },
      openServiceItemModal () {
        this.$refs.serviceItemModal.showModal(true, Number(this.selectedProvinceId))
      },
      setServiceItems (serviceItems) {
        if (serviceItems) {
          this.serviceItems = []
        }
        this.serviceItems = serviceItems
        this.calculateTotalPrice()
        this.errorServiceItems = false
      },
      clearSelectedServiceItems () {
        this.serviceItems = null
        this.calculateTotalPrice()
        this.$refs.serviceItemModal.clearData()
      }
    },
    mounted () {
      this.clearOldBookingData()
      // Set parent service id
      if (this.$route.query.sid) {
        this.parentServiceId = Number(this.$route.query.sid)
        // Check parentService === null
        if (!this.parentService) {
          this.parentService = this.globalState.services[this.parentServiceId]
        }
      }
      // Check case professional has no cleaning service such as only ironing or ac cleaning service
      if (this.professional.services.findIndex(service => service.id === 1) === -1) {
        this.parentServiceId = this.professional.services[0].id
        this.parentService = this.globalState.services[this.parentServiceId]
      }
      // Check parentService === null
      if (!this.parentService) {
        this.parentService = this.globalState.services[this.parentServiceId]
      }
      // Check service whice has service items
      if (this.parentService && this.parentService.has_service_items) {
        this.selectedServiceId = this.parentServiceId
      }
      this.initBookingData()
      // Save user event log
      userEventLogHelpers.logEvent('begin_booking_professional', {
        service_id: this.parentServiceId,
        professional_id: this.professionalId
      })
    }
  }
</script>

<style scoped>
  .input-text-icon {
    float: right;
    margin-right: 0.5rem;
    margin-top: -1.7rem;
    position: relative;
    font-size: 110%;
    z-index: 2;
    color: #9E9E9E;
  }

  .inactive {
    background-color: #ECEFF1;
  }

  .active {
    background-color: white;
    color: #212121;
    font-weight: 500;
  }

  .active::after {
    content: "";
    display: block;
    height: 0.25rem;
    width: 75%;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background: #00ACC1;
    border-radius: 999px;
  }

  .modal {
    z-index: 999999 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/professional/components/BookCleanerForm.vue